const SET_INFO = 'SET_INFO'; // 设置用户信息

export {
  SET_INFO,
};
export default SET_INFO;
